import type { AccountBalance } from '@api/hooks/useBalance.ts';
import { Typography } from '@gurupay/gp-ui-library';
import { AccountInfo } from '@pages/accounts/components';
import { formatWithCurrency } from '@utils/utils.ts';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface AccountSlideProps {
	balance: AccountBalance;
}

export const AccountSlide: FC<AccountSlideProps> = ({ balance }) => {
	const { t } = useTranslation('', { keyPrefix: 'totalBalance' });

	return (
		<Link
			className="block border border-neutral-100 p-space-16 rounded-sm space-y-space-16 hover:bg-neutral-50 transition-colors"
			onClickCapture={(e) => {
				if ((e.target as HTMLElement).closest('button')) {
					e.preventDefault();
				}
			}}
			to={`/accounts/${balance.uuid}`}
		>
			<AccountInfo {...balance} showLabel={false} />
			<div className="flex gap-space-24 justify-between">
				<div className="flex flex-col max-mobile:gap-y-space-2 gap-y-space-8">
					<Typography level="text">{t('availableTotal')}</Typography>
					<div className="max-mobile:text-base-bold text-xl-bold whitespace-nowrap">
						{formatWithCurrency({
							value: balance.available,
							currency: balance.currency,
						})}
					</div>
				</div>

				<div className="flex flex-col max-mobile:gap-y-space-2 gap-y-space-8 items-end">
					<Typography level="text">{t('label')}</Typography>
					<div className="max-mobile:text-base-bold text-xl-bold whitespace-nowrap">
						{formatWithCurrency({ value: balance.balance, currency: balance.currency })}
					</div>
				</div>
			</div>
		</Link>
	);
};
